import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { FileUploadUtil } from '@home365/common-classes';
import { Observable } from 'rxjs';

export interface ProfileFormData {
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  mobilePhone: string;
  profileImage: string;
  businessName: string;
  dob?: number | Date;
  propertyAddress?: string;
}
export interface AwsDataModel {
  accessKeyId: string;
  secretAccessKey: string;
  region: string;
  folder: string;
}
@Component({
  selector: 'lib-home365-base-profile-page',
  templateUrl: './base-profile-page.component.html',
  styleUrls: ['./base-profile-page.component.scss'],
})
export class BaseProfilePageComponent implements OnInit {
  @ViewChild('dateInput', { static: false }) set content(content: ElementRef<MatInput>) {
    if (content) {
      this._focusToBirthDayInput(content);
    }
  }
  form!: FormGroup;
  data?: ProfileFormData;
  isMobile = false;
  focusOnDOB = false;
  minDate!: Date;
  @Input() set dataInput(data: ProfileFormData) {
    this.setFormData(data);
  }

  @Input() aws!: {
    accessKeyId: string;
    secretAccessKey: string;
    region: string;
    folder: string;
  };
  @Input() isTenant = false;
  @Input() isLoading = false;
  @Output() uploadImg = new EventEmitter<Observable<{ src: string }>>();

  constructor(private fb: FormBuilder, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._initForm();
  }

  getFormData() {
    return this.form.value;
  }

  setFormData(data: ProfileFormData) {
    if (data && !this.isTenant) {
      this.data = data;
      this.form.setValue({
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        mobilePhone: data?.mobilePhone,
        propertyAddress: data?.propertyAddress ? data?.propertyAddress : '',
      });
    }
    if (data && this.isTenant) {
      this.data = data;
      this.form.setValue({
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        mobilePhone: data?.mobilePhone,
        propertyAddress: data?.propertyAddress ? data?.propertyAddress : '',
        birthday: data.dob ? new Date(data.dob) : '',
      });
    }
    this.cd.detectChanges();
  }

  isValid() {
    return this.form.valid && this.form.touched;
  }

  validate() {
    this.form.updateValueAndValidity();
  }

  usePhoto(e: any) {
    const fileList: FileList = e?.target?.files;
    const file: File = fileList[0];
    // this.modalService.openLoader();
    const upload = new FileUploadUtil(this.aws.accessKeyId, this.aws.secretAccessKey, this.aws.region, this.aws.folder);
    this.uploadImg.emit(upload.uploadS3Observable(file));
  }

  private _initForm() {
    this.form = this.fb.group({
      firstName: this.fb.control(null, Validators.required),
      lastName: this.fb.control(null, Validators.required),
      email: this.fb.control(null, [Validators.required, Validators.email]),
      mobilePhone: this.fb.control({ value: null, disabled: true }),
      propertyAddress: this.fb.control({ value: null, disabled: true }),
    });

    if (this.isTenant) {
      this.form.addControl('birthday', this.fb.control(null, [Validators.required]));
      const today = new Date();
      this.minDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    }
  }

  private _focusToBirthDayInput(el: ElementRef<MatInput>) {
    if (this.isTenant && this.focusOnDOB) {
      el.nativeElement.focus();
    }
  }

  get emailError() {
    if (this.email.invalid) {
      if (this.email.errors?.['required']) {
        return 'This field is required';
      }
      return 'Please enter valid email';
    }
    return null;
  }

  get firstName(): FormControl {
    return this.form.get('firstName') as FormControl;
  }

  get lastName(): FormControl {
    return this.form.get('lastName') as FormControl;
  }

  get email(): FormControl {
    return this.form.get('email') as FormControl;
  }

  get birthday(): FormControl | null {
    if (this.form.get('birthday')) {
      return this.form.get('birthday') as FormControl
    } else {
      return null
    }
  }

  get mobilePhone(): FormControl {
    return this.form.get('mobilePhone') as FormControl;
  }

  get propertyAddress(): FormControl {
    return this.form.get('propertyAddress') as FormControl;
  }
}
